@if (this.URL) {
  <iframe #networkframe class="networkframe" [src]="this.URL"> </iframe>
}
